<template>
  <div class="announcement">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div v-if="!this.$route.query.id" class="list">
      <div class="listHeader">
        <div class="headInfo">
          <div class="headTitle">公告列表</div>
          <div class="headTip">了解平台最新公告与服务动态</div>
        </div>
      </div>
      <div class="listBody">
        <router-link v-for="(item,index) in announcementList" :key="index" class="listItem" :to="{name:'Announcement',query:{id:item.id}}">
          <div id="itemTitle">{{item.title}}</div>
          <div id="itemDate">{{item.add_time|moment}}</div>
          <div id="itemBtn">查看</div>
        </router-link>
      </div>
      <common-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="PageSize"
        :total="totalCount">
      </common-pagination>
    </div>
    <div v-else class="content">
      <div class="contentTitle">{{announcementList[0].title}}</div>
      <div class="contentInfo">
        <div class="contentDate">发布时间：{{announcementList[0].add_time|moment}}</div>
        <div class="contentClick">点击数：{{announcementList[0].click}}</div>
      </div>
      <div id="content" v-html="announcementList[0].content"></div>
    </div>
  </div>
</template>
<script>
import {apiArticleList} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";
import commonPagination from "@/components/commonPagination";

export default {
  name: 'announcement',
  props: {
  },
  components: {
    breadcrumb,
    commonPagination
  },
  data () {
    return {
      // 默认显示第几页
      currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount:6,
      // 默认每页显示的条数（可修改）
      PageSize:20,
      //id
      id:this.$route.query.id,
      announcementList:[
        {title:''}
      ]
    }
  },
  methods: {
    //分页监听事件
    handleCurrentChange(val) {
      this.currentPage = val
    },
    getannouncementList(id){
      apiArticleList({
        id:id,
        cat_id:1
      }).then(res=>{
        this.announcementList = res.data.list
      })
    }
  },
  mounted(){
    this.getannouncementList(this.$route.query.id)
  },
  watch: {
  },
  computed: {
    breadcrumbList(){
      return [
        {name: this.$route.query.id ? '公告详情' : '公告列表'}
      ]
    }
  },
  created() {
  },
  beforeRouteUpdate(to,from,next){
    this.getannouncementList(to.query.id)
    next()
  }
}
</script>

<style  scoped>
#content{
  overflow: auto;
  margin: 0;
  width: 100%;
  color: var(--text-main, #111827);
  font-size: 15px;
  line-height: 1.9;
}
#content >>> img{
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  border-radius: 4px;
}

</style>

<style lang='less' scoped>
.announcement{
  --page-card-min-height: ~"min(40vh, 480px)";
  width: 1200px;
  margin: 0 auto;
  .list{
    width: 1200px;
    min-height: var(--page-card-min-height);
    padding: 28px 30px 30px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    box-sizing: border-box;
    .listHeader{
      height: 56px;
      display: flex;
      align-items: center;
      padding-bottom: 22px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      box-sizing: content-box;
      .headInfo{
        display: flex;
        flex-direction: column;
        justify-content: center;
        .headTitle{
          font-size: 24px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: var(--text-main, #111827);
          line-height: 32px;
        }
        .headTip{
          margin-top: 4px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 20px;
        }
      }
    }
    .listBody{
      min-height: calc(var(--page-card-min-height) - 146px);
      padding-top: 14px;
      box-sizing: border-box;
      .listItem{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        height: 64px;
        margin-bottom: 14px;
        padding: 0 18px 0 22px;
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: 0 8px 20px rgba(26, 29, 36, 0.04);
        box-sizing: border-box;
        transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease, background .2s ease;
        #itemTitle{
          flex: 1;
          min-width: 0;
          margin-right: 24px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 500;
          color: var(--text-main, #111827);
        }
        #itemDate{
          width: 116px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          white-space: nowrap;
        }
        #itemBtn{
          width: 76px;
          height: 32px;
          margin-left: 28px;
          background: var(--bg-tag, #F0EDE8);
          border-radius: 4px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #1A1D24);
        }
      }
      .listItem:hover{
        transform: translateY(-2px);
        border-color: var(--primary, #FF5A1F);
        background: var(--bg-section, #F7F5F2);
        box-shadow: 0 12px 28px rgba(26, 29, 36, 0.1);
      }
    }
  }
  .content{
    width: 1200px;
    min-height: var(--page-card-min-height);
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    padding: 44px 80px 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    .contentTitle{
      width: 100%;
      font-size: 26px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      color: var(--text-main, #111827);
      line-height: 36px;
      margin: 0 0 16px 0;
      text-align: center;
      word-break: break-word;
    }
    .contentInfo{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      min-height: 30px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 22px;
      margin: 0 0 28px 0;
      div{
        height: 30px;
        line-height: 30px;
        margin: 0 6px;
        padding: 0 12px;
        border-radius: 4px;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
      }
    }
    #content{
      padding-top: 28px;
      border-top: 1px solid var(--border-soft, #E8E4DE);
    }
    #signature{

    }


  }
}
</style>
